import { render } from "./L_LetterElement.vue?vue&type=template&id=4a09c684"
import script from "./L_LetterElement.vue?vue&type=script&lang=js"
export * from "./L_LetterElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__